<div class="listing-status-cell type-icon with-text">
    <div
        class="tooltip-trigger"
        appTooltip
        trigger="hover"
        position="top"
        [componentData]="tooltipText() | multipartTranslate: ': ' | async"
        [showDelay]="200"
        [hideDelay]="200"
    >
        <div
            class="statusWrapper"
            [class.unknown]="imageTrackerWarningType() === ImageTrackerStatusType.UNKNOWN"
            [class.failed]="imageTrackerWarningType() === ImageTrackerStatusType.FAILED"
            [class.skipped]="imageTrackerWarningType() === ImageTrackerStatusType.SKIPPED"
            [class.warning]="imageTrackerWarningType() === ImageTrackerStatusType.EXPORTED_WITH_WARNINGS"
            [class.successful]="imageTrackerWarningType() === ImageTrackerStatusType.SUCCESSFUL"
        >
            @switch (imageTrackerWarningType()) {
                @case (ImageTrackerStatusType.UNKNOWN) {
                    <i class="fa fa-lg fa-question"></i>
                }
                @case (ImageTrackerStatusType.FAILED) {
                    <i class="fa fa-lg fa-cross"></i>
                }
                @case (ImageTrackerStatusType.SKIPPED) {
                    <i class="fa fa fa-chevrons-right"></i>
                }
                @case (ImageTrackerStatusType.EXPORTED_WITH_WARNINGS) {
                    <i class="fa fa-lg fa-warning-triangle"></i>
                }
                @case (ImageTrackerStatusType.SUCCESSFUL) {
                    @if (assetExportDate()) {
                        <i class="fa fa-lg fa-circle-check"></i>
                    } @else {
                        <i class="fa fa-lg fa-regular fa-circle-check"></i>
                    }
                }
            }
        </div>
        <div class="image-tracker-message">
            {{ tooltipText() | multipartTranslate: ': ' | async }}
        </div>
    </div>
</div>
